import {createAction} from 'redux-actions';
import * as Noty from 'noty';
import * as _ from 'lodash';
import {batchActions} from 'redux-batched-actions';
import {push, replace} from 'connected-react-router';
// import { history } from '../../../../../store';
import {
    createLlamaFormatSelector,
    createLlamaFormSelector,
    createLlamaStateSelector,
    createLlamaUploadedMediaSelector
} from "./selectors";
import {isCurrentUserLoggedSelector, currentUserSelector} from "../../../auth/store/auth-user/selectors";
import {loginAnonymously} from "../../../auth/store/auth-anonymously/actions";
import {logout} from "../../../auth/store/auth-user/actions";
import stickerValidator from "../../domain/services/StickerValidator";
import {setGeneratingLoaderVisibility} from "../../../layout/store/actions";
import StickerItemsRepositoryBuilder from "../../domain/factories/StickerItemsRepositoryBuilder";
import {StickerFormatEnum} from "../../domain/enums/StickerFormatEnum";
import {mediaAudioStateSelector} from "../media-audio/selectors";
import {mediaPhotoStateSelector} from "../media-photo/selectors";
import {mediaVideoStateSelector} from "../media-video/selectors";
import {restoreAudio} from "../media-audio/actions";
import {restorePhoto} from "../media-photo/actions";
import {restoreVideo} from "../media-video/actions";
import {StickerCreateStepEnum} from "../../domain/enums/StickerCreateStepEnum";
import cacheManager from '../../domain/services/StickerCache';
import {uploadPhoto} from '../media-photo/actions';
import {uploadAudio} from '../media-audio/actions';
import {uploadVideo} from '../media-video/actions';
import {getCookie} from '../../../../infrastructure/helpers';
import fileUploader from '../../../upload/FileUploader';
import {loadSticker} from "../entities/stickers/actions";
import {loadStickerItems} from "../entities/sticker-items/actions";
// import {loadSticker} from "../entities/stickers/actions";

const namespace = 'CREATE_LLAMA';

export const setForm = createAction(`${namespace}/SET_FORM`);
export const setFormat = createAction(`${namespace}/SET_FORMAT`);
export const setThemeGroup = createAction(`${namespace}/SET_THEME_GROUP`);
export const setTheme = createAction(`${namespace}/SET_THEME`);
export const setTextTemplatesGroup = createAction(`${namespace}/SET_TEXT_TEMPLATES_GROUP`);
export const setTextTemplate = createAction(`${namespace}/SET_TEXT_TEMPLATE`);
export const setText = createAction(`${namespace}/SET_TEXT`);
export const setPhoto = createAction(`${namespace}/SET_PHOTO`);
export const setVideo = createAction(`${namespace}/SET_VIDEO`);
export const setAudio = createAction(`${namespace}/SET_AUDIO`);
export const updateForm = createAction(`${namespace}/UPDATE_FORM`);
export const resetForm = createAction(`${namespace}/RESET_FORM`);
export const restoreForm = createAction(`${namespace}/RESTORE_FORM`);
export const setPreparedMedia = createAction(`${namespace}/SET_PREPARED_MEDIA`);

export const saveStickerItemRequest = createAction(`${namespace}/CREATE_STICKER_ITEM_REQUEST`);
export const saveStickerItemSuccess = createAction(`${namespace}/CREATE_STICKER_ITEM_SUCCESS`);
export const saveStickerItemFailed = createAction(`${namespace}/CREATE_STICKER_ITEM_FAILED`);

export const setCreateStickerOnSignInFlag = createAction(`${namespace}/SET_CREATE_STICKER_ON_SIGN_IN_FLAG`);

export const setScannedStickerItemRequest = createAction(`${namespace}/SET_SCANNED_STICKER_ITEM_REQUEST`);
export const setScannedStickerItem = createAction(`${namespace}/SET_SCANNED_STICKER_ITEM`);

export function checkStepValidation(stepEnum: StickerCreateStepEnum) {
    return (dispatch, getState) => {
        const stickerForm = createLlamaFormSelector(getState());

        function validateFormat() {
            if (stickerForm.format == null || stickerForm.format === '') {
                dispatch(replace('/'));
            }
        }

        switch (stepEnum) {
            case StickerCreateStepEnum.SelectFormat:
                break;
            case StickerCreateStepEnum.VideoConfigure:
            case StickerCreateStepEnum.PhotoConfigure:
            case StickerCreateStepEnum.AudioConfigure:
                break;
            case StickerCreateStepEnum.SelectTheme:
            case StickerCreateStepEnum.InputMessage:
            case StickerCreateStepEnum.Preview:
                validateFormat();
                break;
            case StickerCreateStepEnum.Congratulations:
                break;
        }
    };
}

export function showCreatedSticker() {
    return (dispatch, getState) => {
        const {savedSticker} = createLlamaStateSelector(getState());
        const stickerId = savedSticker.sticker_id;
        // const stickerItemId = savedSticker.id;
        cacheManager.removeCachedSticker(stickerId);
        dispatch(batchActions([
            resetForm(),
            push(`/stickers/${stickerId}`)
        ]));
    };
}

export function restoreCachedSticker(sticker) {
    return (dispatch, getState) => {
        switch (sticker.stickerState.form.format) {
            case StickerFormatEnum.Video:
                let {resultVideoBlob, resultPreviewBlob} = sticker.media;
                const resultVideoExifdata = resultVideoBlob.exifdata;
                const resultPreviewExifdata = resultPreviewBlob.exifdata;

                resultVideoBlob = new Blob([resultVideoBlob.arrayBuffer], {type: 'video/quicktime'});
                resultVideoBlob.exifdata = resultVideoExifdata;
                resultPreviewBlob = new Blob([resultPreviewBlob.arrayBuffer]);
                resultVideoBlob.exifdata = resultPreviewExifdata;

                const resultVideoPath = URL.createObjectURL(resultVideoBlob);
                const resultPreviewPath = URL.createObjectURL(resultPreviewBlob);
                Object.assign(sticker.media, {
                    resultVideoPath,
                    resultPreviewPath,
                    originVideoPath: resultVideoPath,
                    resultVideoBlob,
                    resultPreviewBlob
                });
                dispatch(restoreVideo(sticker.media));
                break;
            case StickerFormatEnum.Image:
                let {originPhotoInfo, resultPhotoInfo} = sticker.media;
                originPhotoInfo.blob = new Blob([originPhotoInfo.blob.arrayBuffer], {type: 'image/png'});
                resultPhotoInfo.blob = new Blob([resultPhotoInfo.blob.arrayBuffer], {type: 'image/png'});

                const originPhotoPath = URL.createObjectURL(originPhotoInfo.blob);
                const resultPhotoPath = URL.createObjectURL(resultPhotoInfo.blob);
                Object.assign(sticker.media, {
                    originPhotoPath,
                    resultPhotoPath,
                    originPhotoInfo,
                    resultPhotoInfo,
                });
                dispatch(restorePhoto(sticker.media));

                break;
            case StickerFormatEnum.Audio:
                let {originAudioBlob} = sticker.media;
                originAudioBlob = new Blob([originAudioBlob.arrayBuffer], {type: 'audio/mpeg'});
                const originAudioPath = URL.createObjectURL(originAudioBlob);
                Object.assign(sticker.media, {originAudioPath, originAudioBlob});
                dispatch(restoreAudio(sticker.media));
                break;
        }
        dispatch(restoreForm(sticker.stickerState));
        dispatch(push(`/stickers/${sticker.stickerState.scannedSticker.sticker_id}/new/preview`));
    }
}

export function saveSticker() {
    return (dispatch, getState) => {
        const isLogged = isCurrentUserLoggedSelector(getState());
        if (isLogged) {
            dispatch(validateStickerAndSave());
        } else {
            dispatch(batchActions([
                setCreateStickerOnSignInFlag(true),
                setGeneratingLoaderVisibility(true),
                loginAnonymously()
            ]));
        }
    };
}

export function validateStickerAndSave() {
    return (dispatch, getState) => {
        dispatch(setGeneratingLoaderVisibility(true));

        const stickerForm = createLlamaFormSelector(getState());
        let mediaBlob;
        switch (stickerForm.format) {
            case StickerFormatEnum.Audio:
                const audioState = mediaAudioStateSelector(getState());
                mediaBlob = audioState.originAudioBlob;
                break;
            case StickerFormatEnum.Image:
                const photoState = mediaPhotoStateSelector(getState());
                mediaBlob = photoState.resultPhotoInfo.blob;
                break;
            case StickerFormatEnum.Video:
                const videoState = mediaVideoStateSelector(getState());
                mediaBlob = videoState.resultVideoBlob;
                break;
        }
        stickerValidator.validate(stickerForm, mediaBlob)
            .then((errors) => {
                if (errors != null) {
                    errors.forEach((errorText) => {
                        showErrorMessage(errorText)
                    });
                    dispatch(setGeneratingLoaderVisibility(false));
                } else {
                    if (fileUploader.isUploading) {
                        fileUploader.onUploadComplete = saveValidatedSticker.bind(validateStickerAndSave, dispatch, getState);
                    } else {
                        saveValidatedSticker(dispatch, getState);
                    }
                }
            })
            .catch((error) => {
                dispatch(batchActions([
                    saveStickerItemFailed(error),
                    setGeneratingLoaderVisibility(false)
                ]));
                if (currentUserSelector(getState()) && currentUserSelector(getState()).isAnonymous) {
                    dispatch(logout());
                }
                showErrorMessage('Ops! Create sticker failed. Please try later');
            });
    };
}

function saveValidatedSticker(dispatch, getState) {
    saveStickerData(dispatch, getState)
        .then((response: any) => response.data)
        .then((savedSticker) => {
            dispatch(batchActions([
                saveStickerItemSuccess(savedSticker),
                setGeneratingLoaderVisibility(false),
                push(`/stickers/${savedSticker.sticker_id}/new/finish`),
                loadSticker(savedSticker.sticker_id),
                loadStickerItems(savedSticker.sticker_id)
            ]));
        })
        .catch((error) => {
            dispatch(batchActions([
                saveStickerItemFailed(error),
                setGeneratingLoaderVisibility(false)
            ]));
            showErrorMessage('Ops! Create sticker failed. Please try later');
        })
        .finally(() => {
            if (currentUserSelector(getState()) && currentUserSelector(getState()).isAnonymous) {
                dispatch(logout());
            }
        })
}

function saveStickerData(dispatch, getState) {
    return prepareStickerForSave(dispatch, getState)
        .then((preparedSticker) => {
            const stickerItem = createLlamaStateSelector(getState()).scannedSticker;
            const accessToken = getCookie('accessToken');
            const stickerRepository = StickerItemsRepositoryBuilder
                .buildWithStickerId(stickerItem.sticker_id);
            return stickerRepository
                .canCurrentUserWriteInStickerItem(stickerItem, accessToken)
                .then(() => stickerRepository.save(preparedSticker))
        });
}

function prepareStickerForSave(dispatch, getState) {
    const format = createLlamaFormatSelector(getState());
    switch (format) {
        case StickerFormatEnum.Audio:
            return prepareAudioSticker(dispatch, getState);
        case StickerFormatEnum.Upload:
        case StickerFormatEnum.Image:
            return preparePhotoSticker(dispatch, getState);
        case StickerFormatEnum.Video:
            return prepareVideoSticker(dispatch, getState);
        default:
            return new Promise((rej) => rej());
    }
}

async function prepareAudioSticker(dispatch, getState) {
    const stickerState = createLlamaStateSelector(getState());
    let uploadedMedia = createLlamaUploadedMediaSelector(getState());
    const stickerItemId = stickerState.scannedSticker.id;
    const preparedMedia = {...stickerState.form, id: stickerItemId};

    if (!uploadedMedia) {
        uploadedMedia = await getUploadedMediaFromCache(stickerItemId);
        if (!uploadedMedia) {
            uploadedMedia = await uploadAudio(dispatch, getState);
        }
    }
    Object.assign(preparedMedia, {audio: uploadedMedia});
    return new Promise((resolve) => resolve(preparedMedia));
}

async function preparePhotoSticker(dispatch, getState) {
    const stickerState = createLlamaStateSelector(getState());
    let uploadedMedia = createLlamaUploadedMediaSelector(getState());
    const stickerItemId = stickerState.scannedSticker.id;
    const preparedMedia = {...stickerState.form, id: stickerItemId};

    if (!uploadedMedia) {
        uploadedMedia = await getUploadedMediaFromCache(stickerState.scannedSticker.sticker_id);
        if (!uploadedMedia) {
            uploadedMedia = await uploadPhoto(dispatch, getState);
        }
    }
    Object.assign(preparedMedia, {photo: uploadedMedia});
    return new Promise((resolve) => resolve(preparedMedia));
}

async function prepareVideoSticker(dispatch, getState) {
    const stickerState = createLlamaStateSelector(getState());
    let uploadedMedia = createLlamaUploadedMediaSelector(getState());
    const stickerItemId = stickerState.scannedSticker.id;

    if (!uploadedMedia) {
        uploadedMedia = await getUploadedMediaFromCache(stickerItemId);
        if (!uploadedMedia) {
            uploadedMedia = await uploadVideo(dispatch, getState);
        }
    }

    const preparedMedia = {...stickerState.form, id: stickerItemId};
    Object.assign(preparedMedia, {video: uploadedMedia});
    return new Promise((resolve) => resolve(preparedMedia))
}

function getUploadedMediaFromCache(stickerItemId) {
    return cacheManager.getCachedSticker(stickerItemId)
        .then((cachedSticker: any) => cachedSticker.uploadedMedia)
}

function showErrorMessage(errorText: string) {
    new Noty({
        type: 'error',
        text: errorText,
        timeout: 3000
    }).show()
}



// WEBPACK FOOTER //
// ./src/app/modules/stickers/store/create-llama/actions.ts